var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgL2Muabanxe = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_51_894)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z",
    fill: "#E9EEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.25 38H-0.75V51H50.25V38Z",
    fill: "url(#paint0_linear_51_894)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.25,
    y: 9.00002,
    width: 16.5,
    height: 16.5,
    rx: 8.25,
    fill: "url(#paint1_linear_51_894)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_51_894)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.4531 18.9395C30.8744 18.3604 30.0714 18.1151 29.0402 18.3914L25.3629 14.7104L25.4115 14.5266C25.6233 13.7319 25.3944 12.8778 24.8144 12.2978C24.2239 11.7068 23.3843 11.4899 22.5904 11.708C22.4771 11.7391 22.389 11.8281 22.359 11.9416C22.329 12.0551 22.3619 12.1758 22.4449 12.2589L23.3303 13.1443C23.5892 13.4038 23.5867 13.8194 23.331 14.0758C23.0773 14.3301 22.6509 14.3297 22.3982 14.0764L21.5126 13.1907C21.4296 13.1076 21.3086 13.0751 21.195 13.1052C21.0815 13.1354 20.9928 13.2237 20.9619 13.3371C20.7469 14.1223 20.9584 14.9671 21.5517 15.5604C22.1302 16.1393 22.9322 16.3855 23.964 16.1086L27.6416 19.7896C27.3672 20.8205 27.6039 21.6157 28.1904 22.2022C28.7817 22.7939 29.6216 23.0092 30.4138 22.7918C30.5271 22.7607 30.6152 22.6717 30.6453 22.5582C30.6753 22.4447 30.6424 22.324 30.5594 22.2409L29.6741 21.3557C29.4153 21.0962 29.4178 20.6806 29.6735 20.4242C29.9303 20.1687 30.3558 20.1728 30.6062 20.4239L31.4919 21.3093C31.5749 21.3924 31.696 21.4249 31.8095 21.3948C31.923 21.3646 32.0116 21.2763 32.0426 21.163C32.2575 20.3779 32.0462 19.5329 31.4531 18.9395Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4026 17.4826L21.2606 20.6249C20.7465 21.1391 20.7465 21.9752 21.2606 22.4894C21.7748 23.0036 22.611 23.0036 23.1251 22.4894L26.267 19.3472L24.4026 17.4826ZM22.8155 21.4665C22.6867 21.5953 22.4782 21.5953 22.3494 21.4665C22.2207 21.3378 22.2207 21.1292 22.3494 21.0005L24.3485 19.001C24.4773 18.8723 24.6858 18.8723 24.8146 19.001C24.9433 19.1298 24.9433 19.3383 24.8146 19.4671L22.8155 21.4665Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0283 12.2898L31.4601 11.7216C31.3532 11.6146 31.1872 11.5942 31.0576 11.672L29.3097 12.7206C29.1258 12.8309 29.0946 13.0846 29.2462 13.2362L29.3853 13.3753L27.1665 15.585L28.0989 16.5175L30.3177 14.3077L30.5137 14.5037C30.6653 14.6553 30.9191 14.6241 31.0294 14.4402L32.078 12.6924C32.1557 12.5627 32.1353 12.3967 32.0283 12.2898Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.3782 34.1889C35.3255 34.1889 36.0931 34.9445 36.0931 35.877C36.0931 36.8096 35.3255 37.5652 34.3782 37.5652C33.4309 37.5652 32.6633 36.8096 32.6633 35.877C32.6633 34.9445 33.4309 34.1889 34.3782 34.1889ZM17.9444 34.1889C18.8917 34.1889 19.6593 34.9445 19.6593 35.877C19.6593 36.3433 19.4673 36.7654 19.1571 37.0708C18.8469 37.3762 18.4181 37.5651 17.9445 37.5651C16.9972 37.5651 16.2296 36.8096 16.2296 35.877C16.2296 34.9444 16.9971 34.1889 17.9444 34.1889ZM12.4543 12.3138L13.4751 16.5338C13.4779 16.5475 13.4812 16.561 13.4848 16.5743L16.1218 27.4754C14.7099 27.6376 13.6336 28.8258 13.6336 30.228C13.6336 31.7536 14.8989 32.9992 16.4487 32.9992H16.7104C15.5384 33.4869 14.7721 34.6183 14.7721 35.877C14.7721 37.6017 16.1926 39 17.9445 39C18.8205 39 19.6136 38.6504 20.1877 38.0853C20.7618 37.5201 21.1169 36.7394 21.1169 35.877C21.1169 34.6183 20.3506 33.4869 19.1787 32.9992H33.1441C31.9722 33.4869 31.206 34.6183 31.206 35.877C31.206 37.6017 32.6264 39 34.3783 39C36.1302 39 37.5507 37.6017 37.5507 35.877C37.5507 34.6184 36.7843 33.4869 35.6124 32.9992H36.6523C37.0548 32.9992 37.3811 32.678 37.3811 32.2818C37.3811 31.8855 37.0548 31.5643 36.6523 31.5643H16.4486C15.7034 31.5643 15.091 30.9616 15.091 30.228C15.091 29.4944 15.7035 28.8915 16.4486 28.8915H34.1794C34.7695 28.8915 35.3161 28.697 35.7519 28.36C36.1854 28.0248 36.5059 27.5477 36.6464 26.9805L39.2124 16.6159C39.2368 16.5443 39.25 16.4677 39.25 16.388C39.25 15.9918 38.9237 15.6706 38.5212 15.6706H35.5674C35.6461 16.144 35.6876 16.6298 35.6876 17.1251C35.6876 22.066 31.619 26.0713 26.6 26.0713C21.5811 26.0713 17.5124 22.066 17.5124 17.1252C17.5124 16.6298 17.554 16.1441 17.6326 15.6707H14.7639L13.7439 11.454C13.6768 11.126 13.3825 10.879 13.0296 10.879H9.97877C9.57629 10.879 9.25 11.2002 9.25 11.5964C9.25 11.9926 9.57629 12.3138 9.97877 12.3138H12.4543Z",
    fill: "url(#paint2_linear_51_894)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_51_894",
    x1: 24.75,
    y1: 38,
    x2: 24.75,
    y2: 51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB85B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9203"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_51_894",
    x1: 26.5,
    y1: 9.00002,
    x2: 26.5,
    y2: 25.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB85B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9203"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_51_894",
    x1: 9.25,
    y1: 22.8304,
    x2: 39.25,
    y2: 22.8304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F64E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262FED"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_51_894"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_51_894"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.25,
    height: 11.25,
    fill: "white",
    transform: "translate(20.875 11.625)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgL2Muabanxe, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/L2muabanxe.090d96fb.svg";
export { ForwardRef as ReactComponent };